import React from 'react';
import BaseDialog from './base';
import { nameFromPath } from '../util';


function DeleteDialog(props) {

	const { fieldActionRequest, onClose } = props;
	const handleClose = (confirm) => onClose && onClose(confirm && {});

	return (
		<BaseDialog 
			{...props} 
			onClose={handleClose}
			title="Delete Field" 
			confirmBtnTxt="Yes" 
			cancelBtnTxt ="No"
			>
			{`Are you sure you want to delete the field: ${nameFromPath(fieldActionRequest.path)}`}
		</BaseDialog>
	);
}

export default DeleteDialog;